import './loading.css'

export default function Loading({message}) {
    return(<div className="dashed-card w-100 standard-padding">
        <LoadingSpinner label={message ?? 'Loading Data...'}/>
    </div>)
}

export function LoadingSpinner({label, className, style}) {
    return(
        <div className={className} style={style}>
            <span className="loader"></span>
            {label && <p className='card-label neutral vi-spacer-m'>{label}</p>}
        </div>
    )
}